import script from "./ResumeWorkExperienceDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeWorkExperienceDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeWorkExperienceDetail.vue?vue&type=style&index=0&id=7a8080b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8080b2"]])

export default __exports__